<template>
    <div id="app">
        <a-layout id="components-layout-demo-side">
            <a-layout-header class="header" v-if="logged">
                <img
                    class="logo"
                    :src="require('@/assets/Logo_header.svg')"
                    alt="Clube da Cotação"
                />
                <!-- <img class="logo" :src="require('@/assets/VR_Logo_header.svg')" alt="Logo VR Software" /> -->
                <a-menu
                    mode="horizontal"
                    class="header-menu"
                    :selectedKeys="[selectedHeaderKey]"
                >
                    <template v-for="item in headerMenu">
                        <a-sub-menu v-if="item.children" :key="'sub-' + item.key">
                            <span slot="title">
                                <span class="header-submenu-title">{{ item.label }}</span>
                                <a-icon type="down" class="header-submenu-arrow" />
                            </span>
                            <a-menu-item
                                v-for="childKey in item.children"
                                :key="childKey"
                            >
                                <router-link :to="findItem(childKey).path">
                                    {{ findItem(childKey).label }}
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item v-else :key="item.key">
                            <router-link :to="item.path">
                                {{ item.label }}
                            </router-link>
                        </a-menu-item>
                    </template>
                </a-menu>

                <router-link
                    :to="findItem('nova').path"
                    class="new-quote-cta"
                    :title="findItem('nova').label"
                >
                    <span class="material-icons-outlined" style="font-size: 18px">
                        add
                    </span>
                    <span class="new-quote-cta-label">{{ findItem("nova").label }}</span>
                    <span class="new-quote-cta-label-short">Comprar</span>
                </router-link>

                <div class="header-actions">
                    <announcements-button
                        :count="announcements_unseen_count"
                        @click="announcements_drawer_open = true"
                    />

                    <button
                        type="button"
                        class="support-button"
                        title="Suporte"
                        @click="openSupportChat"
                    >
                        <span class="material-icons-outlined support-icon">
                            support_agent
                        </span>
                        <span class="support-button-label">Suporte</span>
                    </button>

                    <a-dropdown>
                        <div class="user-trigger" :title="user.user_name">
                            <span class="material-icons-outlined user-icon">
                                account_circle
                            </span>
                            <span class="user-name">
                                {{ header_user_name }}
                            </span>
                        </div>

                        <a-menu slot="overlay">
                            <!-- So para quem tem mais de uma conta (ou e master):
                                 com uma so, o item nao trocaria nada. -->
                            <a-menu-item
                                v-if="can_switch_account"
                                @click="open_account_modal"
                            >
                                <span class="material-icons-outlined menu-icon">
                                    swap_horiz
                                </span>
                                Trocar conta
                            </a-menu-item>

                            <a-menu-item>
                                <router-link to="/configuracoes">
                                    <span
                                        class="material-icons-outlined menu-icon"
                                    >
                                        settings
                                    </span>
                                    Configurações
                                </router-link>
                            </a-menu-item>

                            <a-menu-divider />

                            <a-menu-item @click="logout">
                                <span
                                    class="material-icons-outlined menu-icon logout sidebar-icon"
                                >
                                    logout
                                </span>
                                Sair
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
            </a-layout-header>
            <a-layout>
                <a-layout-content>
                    <router-view />
                </a-layout-content>
            </a-layout>
            <template v-if="logged">
                <announcement-modal
                    :announcement="announcement_current"
                    :queue-label="announcement_queue_label"
                    @close="closeAnnouncement"
                />
                <announcements-drawer
                    :open="announcements_drawer_open"
                    :items="announcements_items"
                    @open-item="openAnnouncement"
                    @close="announcements_drawer_open = false"
                />
            </template>
            <account-switcher-modal
                v-if="account_modal_open"
                :accounts="switchable_accounts"
                :current_account_id="current_account_id"
                :is_master="is_master"
                :master_results="visible_master_results"
                :master_status="master_status"
                :busy="switching_account"
                :error="switch_error"
                @search="on_account_search"
                @select="switch_account"
                @close="close_account_modal"
            />
        </a-layout>
    </div>
</template>

<script>
import NotificationContainer from "@/components/notifications/NotificationContainer";
import MobileMenu from "@/components/shared/MobileMenu.vue";
import ContractAlertVue from "./components/cliente/base-components/ContractAlert.vue";
import StorageService from "@/services/TokenService";
import chatIconVue from "./components/shared/chatIcon.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import { setFaviconAndTitle } from "./helpers/docInfo";
import { nativeBridge } from "./helpers/nativeBridge";
import { setBitrixUserData, openBitrixChat } from "./helpers/bitrixChat";
import { createBitrixDeal } from "@/services/BitrixCrmService";
import AuthService from "@/services/AuthService";
import * as CONSTANTS from "@/constants/constants";
import AccountSwitcherModal from "@/components/cliente/base-components/AccountSwitcherModal";
import { account_switcher_mixin } from "@/mixins/account-switcher.mixin";
import { announcements_mixin } from "@/mixins/announcements.mixin";
import AnnouncementModal from "@/components/announcements/AnnouncementModal";
import AnnouncementsDrawer from "@/components/announcements/AnnouncementsDrawer";
import AnnouncementsButton from "@/components/announcements/AnnouncementsButton";
import { cached_features, PRODUCTS_V2, REQUESTS_V2, REQUISITIONS, SELLERS_V2, VISITS } from "@/helpers/features";

export default {
    mixins: [account_switcher_mixin, announcements_mixin],
    components: {
        NotificationContainer,
        MobileMenu,
        ContractAlertVue,
        chatIconVue,
        AccountSwitcherModal,
        AnnouncementModal,
        AnnouncementsDrawer,
        AnnouncementsButton,
    },
    computed: {
        ...mapGetters({ logged: "user/logged" }),
        ...mapState(["user", "whitelabel"]),
        primaryColor() {
            return (
                this.whitelabel.data.colors.primary || "var(--primary-color)"
            );
        },
        menuConfigComputed() {
            return this.resolvedMenu;
        },

        /**
         * menuConfig com a tela nova onde a conta tem o recurso do plano:
         * item com `v2: { feature, path }` troca o path. Sem o recurso (ou
         * antes do cache existir), o path antigo. featureKeys é recarregado a
         * cada navegação, depois do router guard preencher o cache.
         */
        resolvedMenu() {
            return this.menuConfig.map((item) =>
                item.v2 && this.featureKeys.includes(item.v2.feature)
                    ? { ...item, path: item.v2.path }
                    : item
            );
        },

        headerMenu() {
            // "nova" vira um botão de destaque próprio (ver .new-quote-cta),
            // não um item comum da lista horizontal.
            return this.resolvedMenu
                .filter((i) => i.header && i.key !== "nova" && this.allowed(i))
                .map((i) => (i.children ? { ...i, children: i.children.filter((key) => this.allowed(this.findItem(key))) } : i));
        },

        selectedKey() {
            const path = this.$route.path;

            const found = this.resolvedMenu.find((item) => {
                if (!item.path) return false;

                // 👇 ignora tudo que pertence ao painel
                if (item.group === "painel") return false;

                return path.includes(item.path);
            });

            return found ? found.key : "";
        },

        selectedHeaderKey() {
            const path = this.$route.path;

            const found = this.resolvedMenu.find((item) => {
                if (!item.path) return false;

                // 👇 header considera tudo
                return path.includes(item.path);
            });

            return found ? found.key : "";
        },

        openKeys() {
            const current = this.selectedKey;

            const parent = this.resolvedMenu.find(
                (item) => item.children && item.children.includes(current)
            );

            return parent ? [parent.key] : [];
        },
    },

    data() {
        return {
            mobileMenuIsExpanded: false,
            featureKeys: [],
            storage_svc: new StorageService(),
            bitrixDataSent: false,
            bitrixUserData: null,
            bitrixDeal: null,
            creatingBitrixDeal: false,
            menuConfig: [
                {
                    key: "dashboard",
                    label: "Dashboard",
                    path: "/dashboard/",
                    icon: "donut_large",
                    header: true,
                    sidebar: true,
                },
                {
                    key: "cadastros",
                    label: "Cadastros",
                    header: true,
                    children: ["produtos", "fornecedores", "explorar"],
                },
                {
                    key: "cotacoes",
                    label: "Cotação",
                    path: "/cliente/monitores/cotacoes",
                    v2: { feature: REQUESTS_V2, path: "/cliente/monitores/cotacoes-v2" },
                    icon: "donut_large",
                    header: true,
                    sidebar: false,
                    group: "painel",
                },
                {
                    key: "ressuprimento",
                    label: "Ressuprimento",
                    path: "/cliente/monitores/ressuprimento",
                    icon: "inventory_2",
                    header: true,
                    sidebar: false,
                    group: "painel",
                },
                {
                    key: "divergencia",
                    label: "Divergência",
                    path: "/cliente/recompra",
                    icon: "warning",
                    header: true,
                    sidebar: false,
                },
                {
                    key: "compras",
                    label: "Compras",
                    header: true,
                    children: ["visitas", "requisicoes"],
                    feature: [VISITS, REQUISITIONS],
                },
                {
                    key: "visitas",
                    label: "Visitas",
                    path: "/visitas",
                    feature: VISITS,
                },
                {
                    key: "requisicoes",
                    label: "Requisições",
                    path: "/requisicoes",
                    feature: REQUISITIONS,
                },
                {
                    key: "mobile",
                    label: "Mobile",
                    path: "/cliente/monitores/mobile",
                    icon: "smartphone",
                    header: true,
                    sidebar: false,
                    group: "painel",
                },
                {
                    key: "pedidos",
                    label: "Pedidos",
                    path: "/cliente/monitores/pedidos",
                    icon: "receipt_long",
                    header: true,
                    sidebar: false,
                    group: "painel",
                },
                {
                    key: "diagnostico",
                    label: "Diagnóstico",
                    path: "/cliente/monitores/diagnostico",
                    icon: "receipt_long",
                    header: true,
                    sidebar: false,
                    group: "painel",
                },

                // SIDEBAR
                {
                    key: "produtos",
                    label: "Produtos",
                    path: "/produtos/",
                    v2: { feature: PRODUCTS_V2, path: "/produtos-v2/" },
                    icon: "inventory_2",
                    sidebar: true,
                },
                {
                    key: "fornecedores",
                    label: "Meus Fornecedores",
                    path: "/fornecedores/",
                    v2: { feature: SELLERS_V2, path: "/fornecedores-v2/" },
                    icon: "groups",
                    sidebar: true,
                },
                {
                    key: "explorar",
                    label: "Outros Fornecedores",
                    path: "/explorar/",
                    icon: "group_add",
                    sidebar: true,
                },
                {
                    key: "nova",
                    label: "Nova Compra/Requisição",
                    path: "/cliente/cotacao/nova",
                    icon: "add_shopping_cart",
                    header: true,
                    sidebar: true,
                },

                // SUBMENU
                {
                    key: "painel",
                    label: "Painel de Operações",
                    icon: "desktop_windows",
                    sidebar: true,
                    children: [
                        "cotacoes",
                        "ressuprimento",
                        "pedidos",
                        "mobile",
                        "diagnostico",
                    ],
                },

                {
                    // Submenu, como Cadastros: cada relatório é uma página.
                    key: "relatorios",
                    label: "Relatórios",
                    icon: "trending_up",
                    header: true,
                    sidebar: true,
                    children: [
                        "relatorios-compras",
                        "relatorios-ordens-de-compra",
                        "relatorios-whatsapp",
                        "relatorios-analise-de-preco",
                    ],
                },
                {
                    key: "relatorios-compras",
                    label: "Compras",
                    path: "/relatorios/compras",
                },
                {
                    key: "relatorios-ordens-de-compra",
                    label: "Ordem de compras",
                    path: "/relatorios/ordens-de-compra",
                },
                {
                    key: "relatorios-whatsapp",
                    label: "WhatsApp",
                    path: "/relatorios/whatsapp",
                },
                {
                    key: "relatorios-analise-de-preco",
                    label: "Análise de Preço por Cotação",
                    path: "/relatorios/analise-de-preco",
                },
                {
                    key: "ofertas",
                    label: "Ofertas",
                    path: "/ofertas",
                    icon: "local_offer",
                    sidebar: true,
                },
                {
                    key: "config",
                    label: "Configurações",
                    path: "/configuracoes",
                    icon: "settings",
                    sidebar: true,
                },
                {
                    key: "ajuda",
                    label: "Ajuda",
                    path: "/ajuda",
                    icon: "help",
                    sidebar: true,
                },
            ],
        };
    },
    created() {
        this.checkAndSetFaviconAndTitle();
        this.attColorWhitelabel();
        // this.fetchDados();
    },
    mounted() {
        this.fetchDados().then(this.checkAndSetFaviconAndTitle());
        window.addEventListener("popstate", this.onBackButton);
        window.history.pushState(null, null, window.location.href);
        if (this.logged) {
            this.sendBitrixUserData();
            this.load_switchable_accounts();
        }
        this.$root.$on("open-support-chat", this.openSupportChat);
    },
    beforeDestroy() {
        window.removeEventListener("popstate", this.onBackButton);
        this.$root.$off("open-support-chat", this.openSupportChat);
    },
    watch: {
        whitelabel: {
            handler() {
                this.attColorWhitelabel();
            },
            deep: true,
        },
        $route: {
            handler() {
                this.featureKeys = (cached_features() || []).map((feature) => feature.key);
            },
            immediate: true,
        },
        logged(val) {
            if (val) {
                this.sendBitrixUserData();
                // O App.vue monta antes do login: a lista de contas so pode ser
                // pedida quando a sessao existe.
                this.load_switchable_accounts();
            } else {
                this.reset_switchable_accounts();
            }
        },
    },
    methods: {
        //  ...mapActions(['fetchDados']),
        ...mapActions(["fetchDados"]),
        onBackButton() {
            window.history.pushState(null, null, window.location.href);
        },
        checkAndSetFaviconAndTitle() {
            if (
                this.whitelabel.data.imgs.img_window != null &&
                this.whitelabel.data.providers.text_window != null
            ) {
                setFaviconAndTitle(
                    this.whitelabel.data.imgs.img_window,
                    this.whitelabel.data.providers.text_window
                );
            }
        },

        attColorWhitelabel() {
            const primaryColor =
                this.whitelabel.data.colors.primary || "#FF5722";
            const secondaryColor =
                this.whitelabel.data.colors.secondary || "#fb6000";
            document.documentElement.style.setProperty(
                "--primary-color",
                primaryColor
            );
            document.documentElement.style.setProperty(
                "--secondary-color",
                secondaryColor
            );
            document.documentElement.style.setProperty(
                "--primary-color-opacity",
                primaryColor + 25
            );
            document.documentElement.style.setProperty(
                "--secondary-color-opacity",
                secondaryColor + 26
            );
        },

        setMobileMenu(value) {
            this.mobileMenuIsExpanded = value;
        },
        // Busca (uma vez só) os dados do usuário logado usados pra alimentar o
        // Bitrix - tanto o prefill de fundo (sendBitrixUserData) quanto a criação
        // do Deal na hora de abrir o chat (openSupportChat) reaproveitam o cache.
        fetchBitrixUserData() {
            if (this.bitrixUserData) return Promise.resolve(this.bitrixUserData);

            return new AuthService()
                .get_user()
                .then((response) => response.data)
                .then((data) => {
                    const usuario = data.usuario || {};
                    const cliente = usuario.cliente || {};

                    this.bitrixUserData = {
                        userId: usuario.usu_id,
                        name: usuario.usu_nome,
                        email: usuario.usu_email,
                        phone: usuario.usu_telefone,
                        company: cliente.cli_nome,
                        cliId: cliente.cli_id,
                        grupo: cliente.cli_nome_grupo,
                    };

                    return this.bitrixUserData;
                });
        },
        sendBitrixUserData() {
            if (this.bitrixDataSent) return;
            this.bitrixDataSent = true;

            this.fetchBitrixUserData()
                .then((userData) => setBitrixUserData(userData))
                .catch(() => {
                    this.bitrixDataSent = false;
                });
        },
        openSupportChat() {
            // Não trava em cima de `this.bitrixDeal` - cada clique reconsulta o
            // Bitrix (findOpenDealId/CLOSED) pra decidir se reaproveita o Deal
            // ou cria um novo (ex.: o atendente fechou o Deal entre um clique e
            // outro, no mesmo carregamento de página). Só evita disparar duas
            // checagens em paralelo se o usuário clicar de novo enquanto a
            // anterior ainda está em andamento.
            if (this.creatingBitrixDeal) {
                openBitrixChat();
                return;
            }

            this.creatingBitrixDeal = true;

            this.fetchBitrixUserData()
                .then((userData) =>
                    createBitrixDeal(userData).then((deal) => ({ userData, deal }))
                )
                .then(({ userData, deal }) => {
                    if (!deal) return;
                    this.bitrixDeal = deal;
                    setBitrixUserData({ ...userData, ...deal });
                })
                .catch(() => {})
                .finally(() => {
                    this.creatingBitrixDeal = false;
                    openBitrixChat();
                });
        },
        isCliVindi() {
            return this.storage_svc.get("cli_vindi") == 1;
        },
        go(path) {
            this.$router.push(path);
        },
        logout() {
            this.$store.dispatch("user/logout");
            nativeBridge.send({ type: "logout" });
            window.location.assign(CONSTANTS.ROUTE_LOGIN);
        },
        findItem(key) {
            return this.resolvedMenu.find((i) => i.key === key);
        },
        allowed(item) {
            return !item.feature || [].concat(item.feature).some((key) => this.featureKeys.includes(key));
        },
    },
};
</script>

<style lang="scss">
@import "./sass/app.scss";
.ant-tooltip {
    max-width: none !important;
    width: fit-content !important;
}
.ant-menu-horizontal > .ant-menu-item {
    top: 0 !important;
    padding: 0 14px !important;
}
.ant-menu-horizontal > .ant-menu-submenu {
    top: 0 !important;
}
.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title {
    padding: 0 26px 0 14px !important;
}
.header-submenu-title {
    position: relative;
    top: 2px;
}
.body {
    padding: 10px 10px;
    margin: 74px 10px 0 10px !important;
    background-color: #fff;
    overflow-y: visible;
    overflow-x: auto;
    min-height: calc(100vh - 84px);
}

.monitors {
    background-color: #f5f5f5;
}

div:has(.order-page-container) .monitors > .body {
    padding: 64px 0 0;
    width: 100vw !important;
    // background-color: #f5f5f5;
    margin: 0 !important;
}
.page {
    margin: 10px;
}
#components-layout-demo-side .logo {
    width: 120px;
    height: 31px;
    // background: rgba(255, 255, 255, 0.2);
    margin: 16px 24px 16px 0;
    flex-shrink: 0;
    margin-right: 16px;
}
.content {
    flex: 1;
    overflow: auto;
    max-width: 100%;
}

.content-inner {
    background: #fff;
    min-height: 100%;
}

ul {
    padding: 0 !important;
}

.ant-select-tree li ul {
    padding: 0 0 0 18px !important;
}

.sidebar-icon {
    font-size: 20px;
    margin-right: 10px;
}

.ant-menu-item {
    display: flex;
    align-items: center;
}

.header {
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 99;
    width: 100%;
    padding: 0 30px 0 10px !important;
}

/**
 * Esconde o launcher flutuante padrão do Bitrix - substituído pelo ícone de
 * suporte no header (ver .support-icon e openBitrixChat em
 * src/helpers/bitrixChat.js). Seletor confirmado inspecionando o widget real
 * no DevTools.
 */
.b24-widget-button-inner-container {
    display: none !important;
}

/**
 * Reposiciona o painel do chat do Bitrix - mais à esquerda e mais abaixo do
 * que a posição padrão da biblioteca (bottom: 130px; right: 53px;), que veio
 * assim de fábrica quando o botão flutuante padrão ficava no canto inferior
 * direito.
 */
.bx-livechat-wrapper.bx-livechat-position-bottom-right {
    right: 40px !important;
    bottom: 40px !important;
}

.ant-layout-content {
    display: block !important;
    background-color: #f5f5f5;
}

.header .ant-menu-horizontal {
    line-height: 48px;
    height: 48px;
    border-bottom: none;
    padding-top: 0px !important;
    background: transparent !important;
}

.header-submenu-arrow {
    position: absolute !important;
    top: 50% !important;
    right: 10px !important;
    transform: translateY(calc(-50% + 4px));
    font-size: 8px !important;
    margin: 0 !important;
    min-width: auto !important;
    color: inherit;
}

.ant-menu-submenu-popup .header-submenu-arrow {
    display: none !important;
}

.header .ant-menu-item {
    height: 48px;
    align-items: center;
}

.header-menu {
    flex: 1;
    min-width: 0;
    margin-left: 20px;
    border-bottom: none;
}

.new-quote-cta {
    flex-shrink: 0;
    align-self: center;
    margin-right: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 34px;
    box-sizing: border-box;
    background: var(--primary-color, #ff5722);
    color: #fff !important;
    padding: 0 16px;
    line-height: 1;
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    transition: opacity 0.2s;
}

.new-quote-cta:hover {
    opacity: 0.88;
    color: #fff !important;
}

.new-quote-cta-label-short {
    display: none;
}

@media only screen and (max-width: 1366px) {
    .new-quote-cta {
        padding: 0 12px 0 8px;
    }
    .new-quote-cta-label-short {
        display: inline;
    }
    .new-quote-cta-label,
    .support-button-label,
    .user-name {
        display: none;
    }
    .header-actions button.support-button {
        padding: 6px;
    }
}

.header-actions {
    flex-shrink: 0;
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 16px;
    color: #fff;
}

.ant-menu-submenu-popup .ant-menu {
    padding: 0 !important;
    margin: 0 !important;
    background-color: #fafafa !important;
}

.header-actions .support-button {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    padding: 6px 14px;
    background: transparent !important;
    color: #525252 !important;
    font-size: 14px;
    font-family: inherit;
    line-height: 1;
    white-space: nowrap;
    transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.header-actions .support-button:hover {
    background: #eeeeee !important;
    border-color: #ff432d;
    color: #ff432d !important;
}

/* A regra global ".header-actions *" (mais abaixo) força cor/fundo cinza em
   qualquer descendente, incluindo o ícone - sobrescrevemos aqui pra ele
   acompanhar a cor do botão (inclusive no hover). */
.header-actions .support-button .support-icon {
    color: inherit !important;
    background: transparent !important;
    font-size: 18px;
}

.user-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #fff;
    padding: 0 10px;
    border-radius: 6px;
    transition: background 0.2s;
}

.user-trigger:hover {
    background: rgba(255, 255, 255, 0.1);
}

.user-icon {
    font-size: 22px;
}

.menu-icon {
    font-size: 18px;
    margin-right: 8px;
    vertical-align: middle;
}

.logout {
    color: #ff4d4f;
}

.user-name {
    padding: 0;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.ant-menu-dark,
.ant-menu-dark .ant-menu-sub,
.ant-layout-header,
.ant-layout-sider-trigger,
.ant-layout-sider-children,
.ant-menu-item,
.header-actions * {
    color: #525252 !important;
    background-color: #fafafa !important;
}
.ant-menu-item-selected {
    color: black !important;
    border-bottom: 2px solid #ff432d !important;
}
.ant-menu-item-active,
.ant-menu-submenu-active,
.ant-menu-submenu-active .ant-menu-submenu-title {
    background-color: #eeeeee !important;
    color: #ff432d !important;
    border: none;
    border-color: #ff432d !important;
}

.ant-menu-item a,
.ant-menu-submenu a,
.ant-menu-item-selected a,
.ant-menu-item a.router-link-active,
.ant-menu-item a.router-link-exact-active {
    color: inherit !important;
}

.align-icon {
    vertical-align: text-bottom;
}
:root {
    --primary-color: var(--primary-color);
    --primary-color-opacity: var(--primary-color);
    --secondary-color: var(--secondary-color);
    --secondary-color-opacity: var(--secondary-color);
}
.fade-enter {
    opacity: 0;
}
.fade-leave-to {
    opacity: 0;
}
.fade-leave-active,
.fade-enter-active {
    transition: opacity 0.3s ease-out;
}
.page-body-y {
    // margin-top: 18vh;
    min-height: 100vh;
}
.page-body-x {
    // margin-left: 9vw;
}
.sidebar-toggle {
    font-size: 24px;
    cursor: pointer;
    margin-right: 16px;
    display: flex;
    align-items: center;
}
@media only screen and (max-width: 720px) {
    .body {
        padding: 0px !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    .header .ant-menu-horizontal {
        flex: 1;
        min-width: 0;
        overflow: hidden;
    }
    .header {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 100vw;
        overflow: hidden;
        padding: 0 4px 0 8px !important;
    }
    .logo {
        margin-right: 8px !important;
    }
    .ant-menu-submenu-selected {
        color: black !important;
    }
    div:has(.order-page-container) .monitors > .body {
        padding: 64px 0 0;
        width: 100vw !important;
        // background-color: #f5f5f5;
        margin: 64px 0 !important;
        min-height: calc(100vh - 84px);
        overflow: visible;
    }
    .page-body-x {
        margin-left: 1vw;
    }
    .page-body-y {
        margin-top: 5vh;
    }
}
.qv-drawer {
    z-index: 1050 !important;
    top: 74px !important;
}

.qv-drawer .ant-drawer {
    position: absolute !important;
    inset: 0 !important;
}

.qv-drawer .ant-drawer-content-wrapper {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    height: 90% !important;
    box-shadow: none !important;
}

.qv-drawer .ant-drawer-content {
    height: 100% !important;
}
</style>
